import React, {Fragment} from "react";
import useListboxFetch from "root/ReactHookForm/ui/useListboxFetch";
import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import {DEFAULT_LEA} from "root/s360components/ui/DropdownLeas";

const DropdownSchools2 = ({onChange, lea_id, control, name, rules, placeholder, isSearchable, isClearable, readOnly}) =>
{
    //Callers that do not filter by LEA keep the old behaviour of listing the default LEA's schools
    const leaId = lea_id === undefined ? DEFAULT_LEA.value : lea_id ;

    //A null url tells useListboxFetch not to fetch at all, so no LEA means no request
    const url = leaId === null ? null : '/lea/' + leaId + '/schools' ;

    const fields = { url: url, keyFieldName: 'school_id', labelFieldName: 'school_name', additionalFields: ['enc_school_id'] }

    const [ isLoading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            {isLoading === true && <div className='form-control'><SpinnerDiv/></div>}
            {isLoading === false && <CommonDropdown items={items} control={control} name={name} rules={rules}
                                                    onChange={onChange} readOnly={readOnly}
                                                    isSearchable={isSearchable} isClearable={isClearable}
                                                    placeholder={placeholder}/>}
        </Fragment>
    )
}
export default DropdownSchools2;
